module.exports = __webpack_public_path__ + "static/media/arrow_lightblue.bf6eae43.svg";